
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const EditPackageLoading = () => {
  return (
    <>
      <Header />
      <div className="container max-w-2xl mx-auto py-8 px-4">
        <div className="animate-pulse">Loading...</div>
      </div>
      <Footer />
    </>
  );
};
